module.exports = __webpack_public_path__ + "img/phone-ic-popup-light.5d926665.svg";